import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Card, CardBody, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap';
import { updateClient } from 'store/actions';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import client_info from '../../assets/images/svg/client/client-info.svg'
import kyc from '../../assets/images/svg/client/kyc-details.svg'
import Skeleton from 'react-loading-skeleton';

const ViewClient = () => {
    document.title = `View client | Glottis Logistics`;

    const { id } = useParams();
    const history = useHistory()
    const dispatch = useDispatch()
    const client = useSelector(state => (state.AddClient01.user))
    const loader = useSelector(state => (state.AddClient01.loader))
    useEffect(() => {
        if (id) {
            dispatch(updateClient(id))
        }
    }, [id]) 

    return (
        <div className="page-content view-client">
            <Breadcrumbs title="Clients" dashurl="/clients" breadcrumbItem="Client details" />
            <Form>
                <Card>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={client_info} alt="" />
                            </div>
                            <p className='f-size-16 fw-600 mb-0'>Client information</p>
                        </div>
                        <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Client code</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.clientCode}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                        }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Company name</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.name}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Company email</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.email}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>House.no / Building.no</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.address_1}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="8">
                                <FormGroup className="mb-3">
                                    <Label>Street address</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.address_2}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Country</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.country}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>State</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.state}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>City</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.city}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Postal code</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.postalCode}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>Company phone number</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.phone}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <div className='avater d-flex'>
                            <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                <img src={kyc} alt="" />
                            </div>
                            <p className='f-size-16 fw-600 mb-0'>KYC details</p>
                        </div>
                        <Row>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>GST number</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.gst}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>PAN number</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.pan}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup className="mb-3">
                                    <Label>TAN number</Label>
                                    {!loader ?
                                        <Label className='form-control d-flex align-items-center'>{client?.tan}</Label> :
                                        <div>
                                            <Skeleton height={"53px"} width={'100%'} />
                                        </div>
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
                <div className='text-center mb-30'>
                    <button className="primary-button" type="button" onClick={() => history.push('/clients')}>
                        Back
                    </button>
                </div>
            </Form >
        </div>
    )
}

export default ViewClient